

















































import { Component, namespace, mixins, Prop } from 'nuxt-property-decorator'
import { mdiDeleteForeverOutline, mdiHeart, mdiHeartOutline } from '@mdi/js'
import { ICompareExtendItem } from '~/assets/interfaces/compare'
import {
  IFavouriteItem,
  IProductToCart,
  IProductToCompare,
  IProductToFavourites,
} from '~/assets/interfaces/products'
import MixinGeneral from '~/assets/mixins/general'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'
import ComponentPrice from '~/components/price/price.vue'
import ComponentImage from '~/components/images/image.vue'
import ComponentProductBuyButton from '~/components/products/product-buy-button.vue'

const compareStore = namespace('compare')
const cartStore = namespace('cart')
const favouritesStore = namespace('favourites')

@Component({
  components: {
    ComponentProductBuyButton,
    ComponentFormButtonIcon,
    ComponentPrice,
    ComponentImage,
  },
})
export default class ComponentCompareItem extends mixins(MixinGeneral) {
  @Prop({ type: Object, default: () => {}, required: true })
  readonly product: ICompareExtendItem

  @Prop({ type: Boolean, default: false })
  readonly fixed: boolean

  @compareStore.Action('toCompare') private toCompareAction!: (
    product: IProductToCompare
  ) => Promise<void>

  @cartStore.Action('toCart') private toCart!: (
    product: IProductToCart
  ) => Promise<void>

  @favouritesStore.State('items') private favouritesItems!: IFavouriteItem[]
  @favouritesStore.Action('toFavourites') private toFavourites!: (
    product: IProductToFavourites
  ) => Promise<void>

  private icons = {
    mdiDeleteForeverOutline,
    mdiHeartOutline,
    mdiHeart,
  }

  private async toCompare(product: IProductToCompare) {
    this.$emit('loading', true)
    await this.toCompareAction(product)
    this.$emit('loading', false)
  }

  private isLoadingFavourites = false

  private isInFavourites(id: number) {
    return !!this.favouritesItems.find((item) => {
      return item.id === id
    })
  }

  private async addToFavourites(id: number) {
    const tempProd = {
      id,
    }

    this.isLoadingFavourites = true
    await this.toFavourites(tempProd)
    this.isLoadingFavourites = false
  }

  private classToFavouriteButton(id: number) {
    return {
      [this.$style.toFavouriteButton]: true,
      [this.$style.active]: this.isInFavourites(id),
      ...this.classDevice(this.$style),
    }
  }
}
